/**
 * SEOHead - Dynamic meta tags for SEO and social sharing (Open Graph + Twitter Cards)
 */
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'One Voice Distro';
const DEFAULT_DESC = 'Independent music distribution platform. Upload, distribute, and monetize your music. Keep ~90% of every sale.';
const DEFAULT_IMG = 'https://images.pexels.com/photos/1105666/pexels-photo-1105666.jpeg';

export default function SEOHead({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  artist,
  audioUrl 
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;
  const pageUrl = url || window.location.href;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Music-specific (for tracks) */}
      {type === 'music.song' && artist && (
        <meta property="music:musician" content={artist} />
      )}
      {audioUrl && <meta property="og:audio" content={audioUrl} />}
    </Helmet>
  );
}
